import { SxProps, Theme } from '@mui/material';

export const appBarSx: SxProps<Theme> = (theme) => ({
  borderBottom: '1px solid rgba(0,0,0,0.06)',
  borderRadius: 0,
  ml: '224px',
  width: `calc(100% - 224px)`,
  zIndex: (theme as Theme).zIndex.drawer + 1,
});

export const toolbarSx: SxProps<Theme> = { minHeight: '56px', alignItems: 'center', height: '56px' };

export const adminTextSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '-0.08px',
  color: '#374151',
};

export const productionChipSx: SxProps<Theme> = {
  width: '73.2109375px',
  height: '24px',
  backgroundColor: '#A7F3D0',
  color: '#60AF97',
  borderRadius: '9999px',
  border: `1px solid #60AF97`,
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 600,
  fontSize: '10px',
  lineHeight: '15px',
  letterSpacing: '0.12px',
  opacity: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 0,
  '&:hover': { backgroundColor: '#A7F3D0' },
};

export const userBoxSx: SxProps<Theme> = { ml: 'auto', display: 'flex', alignItems: 'center', gap: 2 };

export const topUserNameSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 600,
  fontStyle: 'normal',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '-0.08px',
  textAlign: 'center',
};

export const topAvatarSx: SxProps<Theme> = {
  width: '28px',
  height: '28px',
  borderRadius: '16777200px',
  bgcolor: '#143133',
  color: '#FFFFFF',
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 700,
  fontSize: '9px',
  lineHeight: '13.5px',
  letterSpacing: '0.17px',
};

export const menuItemTextSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '-0.08px',
  textAlign: 'center',
};
